<template>
  <form class="legal-text-form uk-form-stacked" @submit.prevent="submit">
    <text-input ref="name" :label="$t('fields.name')"
                v-model="form.model.name"
                :errors="form.errors.name"
                :disabled="!isEditable" />
    <markdown-editor v-model="form.model.plainBody"
                     :label="$t('fields.plainBody')"
                     :errors="form.errors.plainBody"
                     rows="10"
                     :disabled="!isEditable"/>
    <submit-button type="primary" :disabled="!isSubmittable" />
    <cancel-button />
  </form>
</template>

<script>
import Form from '@/mixins/LegacyForm';
import MarkdownEditor from '@/components/MarkdownEditor';

export default {
  name: 'legal-text-form',
  components: {
    MarkdownEditor,
  },
  mixins: [
    Form({
      name: { required: true },
      plainBody: { required: true },
    }),
  ],
  mounted() {
    this.$refs.name.focus();
  },
};
</script>



// WEBPACK FOOTER //
// LegalTextForm.vue?266da459